import {CanMatchFn} from '@angular/router';
import {ShellLoadFailureKind} from '../../../services/auth/shell-load-failure.util';

const allowedFixtureTargets = new Set(['dashboard', 'chatbots']);
const allowedFixturePaths = new Set(['/ai/dashboard', '/ai/chatbots']);
const allowedFixtureStates = new Set([
  'beta-unavailable',
  'auth-required',
  'access-denied',
  'load-failed',
  'no-client-access',
  'account-selection-required',
]);
export type InterfaceLoadVisualFixtureState = 'beta-unavailable' | ShellLoadFailureKind;

export function readInterfaceLoadVisualFixture(href: string): {state: InterfaceLoadVisualFixtureState; target: 'dashboard' | 'chatbots'} | null {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('interfaceLoadVisualFixture') || '';
  const fixtureTarget = url.searchParams.get('interfaceLoadFixtureTarget') || '';

  if (!isLocalHost
    || !allowedFixturePaths.has(url.pathname)
    || !allowedFixtureStates.has(fixtureState)
    || !allowedFixtureTargets.has(fixtureTarget)) {
    return null;
  }

  return {
    state: fixtureState as InterfaceLoadVisualFixtureState,
    target: fixtureTarget as 'dashboard' | 'chatbots',
  };
}

export function isInterfaceLoadVisualFixtureUrl(href: string): boolean {
  return readInterfaceLoadVisualFixture(href) !== null;
}

export const interfaceLoadVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isInterfaceLoadVisualFixtureUrl(window.location.href);
};
